import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal", "goalsCheckbox", "activitiesCheckbox", "spendingsCheckbox", "memoryCheckbox"]

  connect() {
    this._onKeydown = (event) => {
      if (event.key === "Escape" && this._isOpen()) this.hide()
    }
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
  }

  show(event) {
    if (event) event.preventDefault()
    this.modalTarget.style.display = "flex"
  }

  hide(event) {
    if (event) event.preventDefault()
    this.modalTarget.style.display = "none"
  }

  _isOpen() {
    return this.hasModalTarget && this.modalTarget.style.display !== "none"
  }

  save(event) {
    event.preventDefault()
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    const preference = {
      goals_tracking: this.goalsCheckboxTarget.checked,
      activities_tracking: this.activitiesCheckboxTarget.checked,
      spendings_tracking: this.spendingsCheckboxTarget.checked,
      notify: true
    }

    // Only present when the :chatbot_cross_chat_memory flag is on (toggle is flag-gated).
    if (this.hasMemoryCheckboxTarget) {
      preference.memory_enabled = this.memoryCheckboxTarget.checked
    }

    const data = { chat_session_preference: preference }

    fetch("/chat_session/preferences", {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(data)
    }).then(response => {
      const isJson = response.headers.get("Content-Type")?.includes("application/json")
      return (isJson ? response.json() : Promise.resolve({})).then(data => {
        if (response.ok) {
          this.modalTarget.style.display = "none"
          this._updateAlertBanner()
        }
        if (data.flash) flash_message(data.flash.type, data.flash.message)
      })
    }).catch(error => {
      console.error("Failed to save preferences:", error)
    })
  }

  stopPropagation(event) {
    // The Plaid launcher (plaid_financial_authentications/_js_new_financial_auth) listens for
    // .link-button clicks on document, so the "Link account" CTA must keep bubbling. On its way
    // up it also hits the overlay's hide, so the modal closes as Plaid opens over the chat.
    if (event.target.closest(".link-button")) return

    event.stopPropagation()
  }

  _updateAlertBanner() {
    const alertBanner = document.getElementById("settings-alert")
    if (alertBanner) {
      alertBanner.remove()
    }
  }
}
